import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "List of things I need to do before I'm 30",
  "description": "",
  "published": "2010-06-10T00:00:00.000Z",
  "redirect_from": ["/blog/list-of-things-i-need-to-do-before-im-30/swizec/1359"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`So I was thinking, for the longest of times I've been wanting to do a whole bunch of things ...`}</p>
    <p>{`... and I never quite get around to doing them.`}</p>
    <p>{`Fuck. This. Shit.`}</p>
    <p>{`This year, I make a list and I fucking clear it by the time I'm 30. There is no sense in living if you aren't having way over the top fun with it.`}</p>
    <p>{`Also making a list, publicly posting it and putting a deadline on it is a sure fire way to have a really really really really crappy 30th birthday when you inevitably realise that you've done way too few of these things and have just run out of soup.`}</p>
    <ol>
      <li parentName="ol"><a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/Bungee_jumping",
          "title": "Bungee jumping"
        }}>{`Bungee jump`}</a></li>
      <li parentName="ol">{`Canyoning`}</li>
      <li parentName="ol">{`Solo sky dive from plane`}</li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/BASE_jumping",
          "title": "BASE jumping"
        }}>{`BASE jump`}</a>{` the fjords`}</li>
      <li parentName="ol">{`Flying suit BASE jump the fjords`}</li>
      <li parentName="ol">{`Jump off a few other things with a flying suit`}</li>
      <li parentName="ol">{`Climb Triglav`}</li>
      <li parentName="ol">{`Climb Everest`}</li>
      <li parentName="ol">{`Drive at least one official european `}<a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/Rallying",
          "title": "Rallying"
        }}>{`rally race`}</a></li>
      <li parentName="ol">{`Drive and finish the desert oldsmobile rally (I keep forgetting the name)`}</li>
      <li parentName="ol">{`Ride the trans-siberian railway`}</li>
      <li parentName="ol">{`Learn to do a no handed endo`}</li>
      <li parentName="ol">{`Perform a `}<a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/Tailwhip",
          "title": "Tailwhip"
        }}>{`double tailwhip`}</a>{` with a mountain bike`}</li>
      <li parentName="ol">{`Come to a board meeting with a parachute through the window`}</li>
    </ol>
    <p>{`Noticed a pattern? :P`}</p>
    <p>{`Well I've got 8 (although I like to pretend it's 9) years to do all of this. Will happily take suggestions for things I haven't thought of.`}</p>
    <p>{`EDIT:`}</p>
    <p>{`Oh and 15: Learn to ride a unicycle`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=06bfcd19-405b-4160-9440-b74acc7d6fb9",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      